import script from "./OwnerSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerSearch.vue?vue&type=script&setup=true&lang=js"

import "./OwnerSearch.vue?vue&type=style&index=0&id=57a6cc64&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a6cc64"]])

export default __exports__